import {POSITION_ACTION_TYPES} from './positionStatement.types';
import {createAction} from '../../utils/redcuerUtils'


export const setClientList = (data:any) => createAction(POSITION_ACTION_TYPES.SET_CLIENT_LIST, data);


export const setPositionStatement = (data:any) => createAction(POSITION_ACTION_TYPES.SET_POSITION_STATEMENT, data);